import { icons } from '@/assets/icons';
import type { CoreItem } from '@/components/bases/CoreLaunchPadCard';
import type { FAQItem } from '@/global/types/common.type';

export const CORE_ITEMS: CoreItem[] = [
  {
    id: 1,
    icon: icons.ic_flash,
    title: 'Instant Deployment',
    description:
      'Say goodbye to long, ambiguous approval processes and unnecessary gatekeeping. Your core sale is ready to launch—giving you full control over your fundraising with a seamless, efficient process.',
  },
  {
    id: 2,
    icon: icons.ic_shapes,
    title: 'Simple & Intuitive UI',
    description:
      'You don’t need to be a technical expert to launch a core sale. Our user-friendly interface is designed for speed, ease, and efficiency. Every step of the process is streamlined, making it accessible for founders, investors, and community members alike.',
  },
  {
    id: 3,
    icon: icons.ic_tag,
    title: 'Self Funding',
    description:
      'Generate significant funding by selling core licenses, unlocking a lucrative revenue stream for further development.',
  },
  {
    id: 4,
    icon: icons.ic_ocean,
    title: 'Full Transparency',
    description:
      'No hidden fees, no middlemen, no guesswork. LFG Core Launchpad operates on smart contracts for trustless, verifiable transactions with real-time tracking of core sales, uptime, and operator rewards—all secured and audited by Certik.',
  },
  {
    id: 5,
    icon: icons.ic_box,
    title: 'Launch Your Core System',
    description: `Empower your project with independent infrastructure using our Core Technology. Seamlessly deploy, manage, and scale your network to enhance decentralization and performance.`,
  },
  {
    id: 6,
    icon: icons.ic_people,
    title: 'Grow & Reward Your Community',
    description:
      'Empower your community to operate cores, contribute to the network, and earn rewards—deepening their engagement while decentralizing control.',
  },
  {
    id: 7,
    icon: icons.ic_link,
    title: 'Built for Multi-Chain Expansion',
    description:
      'Start your journey on Ethereum today, with future support planned for Base, Solana, and other networks LFG is committed to evolving with Web3, ensuring your project stays ahead as we expand to new networks.',
  },
  {
    id: 8,
    icon: icons.ic_cards,
    title: 'Credit Card Integration',
    description:
      'Accept payments via credit card, this feature bridges the gap between traditional finance and crypto, making core sales accessible to a broader audience beyond just Web3 natives.',
  },
  {
    id: 9,
    icon: icons.ic_status_up,
    title: 'Year-over-Year Growth',
    description:
      'Core sales consistently outperform traditional token sales, making them a superior fundraising mechanism.',
  },
];

export const FAQ_ITEMS_SHORT: FAQItem[] = [
  {
    question: 'What is a Node Sale?',
    answer: `A ]fundraising method that lets projects sell nodes to raise capital while decentralizing their network.`,
  },
  {
    question: 'How do Node owners earn rewards?',
    answer: 'Operators receive ]daily rewards based on ]uptime and network contribution in the project’s token.',
  },
  {
    question: 'Why are Node Sales better than traditional token sales?',
    answer: 'They ]distribute tokens gradually, reducing sell pressure and building a stronger ]community.',
  },
  {
    question: 'How much funding can a Node Sale generate?',
    answer: 'More than a typical token sale, thanks to a tiered pricing model that scales with demand.',
  },
  {
    question: 'How do I launch my own Node Sale?',
    answer: 'LFG offers ]end-to-end support, from strategy and tokenomics to sales execution.',
  },
];

export const OUR_SERVICES: FAQItem[] = [
  {
    question: 'Advisory Services',
    answer: `Leverage our experience across tokenomics, governance, branding, and growth strategy. We act as your thought partner—connecting you with key partners, refining your positioning, and guiding decisions that drive long-term value.`,
  },
  {
    question: 'Community Management',
    answer:
      'We provide the structure and systems that help communities thrive. Whether you’re starting fresh or scaling fast, we support the foundation needed to sustain engagement, trust, and long-term growth.',
  },
  {
    question: 'Customer Support & Education',
    answer:
      'Simplify support and enhance community trust with scalable customer service and a dynamic knowledge base tailored for Web3 projects.',
  },
  {
    question: 'Development Services',
    answer:
      'We build, ship, and scale products from concept to production, helping teams execute faster without chaos through focused MVPs, iterative sprints, node workloads, and smart contracts.',
  },
  {
    question: 'Exchange Listing Strategy',
    answer:
      'We manage the full lifecycle of getting listed—from introductions to major CEXs and DEXs to compliance, documentation, and post-listing strategy. Focused on execution, credibility, and long-term alignment.',
  },
  {
    question: 'Live Streaming Services',
    answer:
      'From Twitter Spaces to full-scale livestreams, we handle event strategy, scripting, creative assets, tech setup, and live moderation. Perfect for AMAs, launches, panels, and community engagement.',
  },
  {
    question: 'Market Making Services',
    answer:
      'We support liquidity and trading stability through trusted partners—focusing on healthy market conditions, strategic coordination, and positioning that encourages long-term sustainability and confidence.',
  },
  {
    question: 'Marketing Services',
    answer:
      'Leverage our experience across Brand Positioning, Narrative Architecture, GTM Strategy, Growth Campaign, Demand Generation, and other marketing services.',
  },
];

// export const OUR_PRODUCTS: FAQItem[] = [
//   {
//     question: 'Core Sale Program',
//     answer: `A Core sale raises capital for blockchain projects while creating a sustainable decentralized network and reward community participation.<br/><br/>Launch and manage Core Sales with our end-to-end platform.`,
//   },
//   {
//     question: 'Unstoppable Domain',
//     answer: `Simplify your identity across Web3. In partnership with Unstoppable Domains, replace your complex wallet addresses with a single Web3 username that works across apps, wallets, and dApps.<br/><br/>Take control of your digital presence with a <b>.LFG</b> domain.`,
//   },
// ];
